var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "referral_purchase-tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "推荐购列表", name: "table" } },
            [
              _c("referral-purchase-table", {
                ref: "referral_purchase_table",
                on: {
                  addActivity: _vm.addActivity,
                  editActivity: _vm.editActivity,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeName === "config"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "推荐购配置", name: "config" } },
                [
                  _vm.activeName === "config"
                    ? _c("referral-purchase-edit", {
                        attrs: { "referral-fn-id": _vm.referralFnId },
                        on: { success: _vm.handleSuccess },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }